import { Alert } from '@bancobarigui/barihaus';
import type { Alerta } from '../types';

interface AlertasSectionProps {
  alertas: Alerta[];
}

export function AlertasSection({ alertas }: AlertasSectionProps) {
  if (alertas.length === 0) return null;

  const alertasErro = alertas.filter((a) => a.tipo === 'erro');
  const alertasAlerta = alertas.filter((a) => a.tipo === 'alerta');

  return (
    <div style={{ marginBottom: 16 }}>
      {alertasErro.length > 0 && (
        <Alert
          message="Erros de validação"
          description={
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {alertasErro.map((alerta, idx) => (
                <li key={idx}>{alerta.message}</li>
              ))}
            </ul>
          }
          type="error"
          showIcon
          style={{ marginBottom: 8 }}
        />
      )}
      {alertasAlerta.length > 0 && (
        <Alert
          message="Atenção às validações"
          description={
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {alertasAlerta.map((alerta, idx) => (
                <li key={idx}>{alerta.message}</li>
              ))}
            </ul>
          }
          type="warning"
          showIcon
        />
      )}
    </div>
  );
}
